import type { TimelineAudioClip, TimelineClip } from './types'

/** Seconds in the output timeline, independent of source playback speed. */
export function audioFadeGain(clip: TimelineClip | TimelineAudioClip, elapsed: number): number {
  const fadeIn = Math.min(clip.effectiveDuration, clip.audioFadeInS ?? 0)
  const fadeOut = Math.min(clip.effectiveDuration, clip.audioFadeOutS ?? 0)
  return Math.max(0, Math.min(1, fadeIn > 0 ? elapsed / fadeIn : 1)) *
    Math.max(0, Math.min(1, fadeOut > 0 ? (clip.effectiveDuration - elapsed) / fadeOut : 1))
}
